module.exports = __webpack_public_path__ + "img/lost-teddy-16x9.0d81c596.jpg";